import React from 'react';
import { Gauge, Wrench, Navigation, Disc, Droplet, Snowflake, Fuel, Fan, Check } from 'lucide-react';
import { PriceCategoryCard } from './PriceCategoryCard';
const categories = [{
  icon: Gauge,
  code: 'PR-01',
  title: 'Діагностика',
  items: [{
    work: 'Діагностика ходової',
    price: '300 грн'
  }, {
    work: 'Комп\u2019ютерна діагностика',
    price: '400 грн'
  }, {
    work: 'Передпродажна перевірка авто',
    price: '1 000 грн'
  }]
}, {
  icon: Wrench,
  code: 'PR-02',
  title: 'Підвіска',
  items: [{
    work: 'Заміна стійки стабілізатора',
    price: '350 грн'
  }, {
    work: 'Заміна втулок стабілізатора',
    price: '250 грн'
  }, {
    work: 'Заміна кульової опори',
    price: '600 грн'
  }, {
    work: 'Заміна амортизатора',
    price: '800 грн'
  }, {
    work: 'Заміна пружини',
    price: '800 грн'
  }, {
    work: 'Заміна важеля підвіски',
    price: '700 грн'
  }, {
    work: 'Розвал-сходження',
    price: '700 грн'
  }]
}, {
  icon: Navigation,
  code: 'PR-03',
  title: 'Рульове управління',
  items: [{
    work: 'Заміна рульового наконечника',
    price: '450 грн'
  }, {
    work: 'Заміна рульової тяги',
    price: '650 грн'
  }, {
    work: 'Заміна рульової рейки',
    price: '2 500 грн'
  }]
}, {
  icon: Disc,
  code: 'PR-04',
  title: 'Ступиця та приводи',
  items: [{
    work: 'Заміна підшипника ступиці',
    price: '800 грн'
  }, {
    work: 'Заміна ступиці в зборі',
    price: '1 000 грн'
  }, {
    work: 'Заміна ШРУСа',
    price: '900 грн'
  }]
}, {
  icon: Droplet,
  code: 'PR-05',
  title: 'Технічне обслуговування',
  items: [{
    work: 'Заміна моторної оливи',
    price: '400 грн'
  }, {
    work: 'Заміна паливного фільтра',
    price: '300 грн'
  }, {
    work: 'Заміна повітряного фільтра',
    price: '150 грн'
  }, {
    work: 'Заміна салонного фільтра',
    price: '150 грн'
  }, {
    work: 'Заміна гальмівної рідини',
    price: '500 грн'
  }]
}, {
  icon: Snowflake,
  code: 'PR-06',
  title: 'Кондиціонер',
  items: [{
    work: 'Діагностика системи кондиціонування',
    price: '300 грн'
  }, {
    work: 'Заправка кондиціонера',
    price: '1 250 грн'
  }, {
    work: 'Пошук витоку',
    price: '500 грн'
  }]
}, {
  icon: Fuel,
  code: 'PR-07',
  title: 'Паливна система',
  items: [{
    work: 'Чистка форсунок',
    price: '800 грн'
  }, {
    work: 'Діагностика форсунок',
    price: '500 грн'
  }, {
    work: 'Ремонт паливного насоса',
    price: '2 000 грн'
  }]
}, {
  icon: Fan,
  code: 'PR-08',
  title: 'Турбіна',
  items: [{
    work: 'Діагностика турбіни',
    price: '500 грн'
  }, {
    work: 'Зняття/встановлення турбіни',
    price: '2 500 грн'
  }, {
    work: 'Реставрація турбіни',
    price: '4 000 грн'
  }]
}];
const benefits = ['Прозорі ціни без прихованих платежів', 'Гарантія на виконані роботи', 'Якісні запчастини та перевірені постачальники', 'Більшість робіт виконуємо в день звернення'];
export function ServicesSection() {
  return <section id="services" className="w-full bg-zinc-950 text-white py-24 px-6 md:px-12 lg:px-20" data-id="element-201">
      <div className="max-w-7xl mx-auto" data-id="element-202">
        {/* Header */}
        <div className="mb-16" data-id="element-203">
          <div className="flex items-center gap-3 mb-4" data-id="element-204">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-205" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-206">
              Прайс-лист
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest mb-3" data-id="element-207">
            Наші послуги
          </h2>
          <p className="text-zinc-500 text-sm max-w-2xl" data-id="element-208">
            Військова точність у кожному ремонті — від планового технічного
            обслуговування до складних спеціалізованих робіт.
          </p>
        </div>

        {/* Unified divider */}
        <div className="flex items-center justify-between mb-8 pb-4 border-b border-white/10" data-id="element-209">
          <div className="flex items-center gap-4" data-id="element-210">
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest" data-id="element-211">
              UNIT 01
            </span>
            <span className="font-['Oswald'] text-2xl font-bold text-white uppercase tracking-widest" data-id="element-212">
              Повний каталог послуг
            </span>
          </div>
          <span className="font-['JetBrains_Mono'] text-xs text-zinc-600 tracking-wider" data-id="element-213">
            {categories.length} КАТЕГОРІЙ
          </span>
        </div>

        {/* Price-list grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-start" data-id="element-214">
          {categories.map((category, index) => <PriceCategoryCard key={category.code} icon={category.icon} code={category.code} title={category.title} items={category.items} index={index} data-id="element-215" />)}
        </div>

        {/* Benefits block */}
        <div className="mt-16 relative bg-neutral-900/50 border border-white/10 p-8 md:p-10" data-id="element-216">
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A]" data-id="element-217" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A]" data-id="element-218" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A]" data-id="element-219" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A]" data-id="element-220" />

          <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-6 uppercase" data-id="element-221">
            Чому обирають нас
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5" data-id="element-222">
            {benefits.map(benefit => <div key={benefit} className="flex items-start gap-3" data-id="element-223">
                <div className="mt-0.5 p-1 bg-[#A3E635]/10 border border-[#A3E635]/30 shrink-0" data-id="element-224">
                  <Check className="w-4 h-4 text-[#A3E635]" strokeWidth={3} data-id="element-225" />
                </div>
                <span className="font-['Oswald'] text-base md:text-lg uppercase tracking-wide text-white leading-snug" data-id="element-226">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>

        {/* Fine-print note */}
        <p className="mt-8 text-zinc-600 text-xs leading-relaxed max-w-3xl font-['Inter']" data-id="element-227">
          Ціни вказані лише за виконання робіт без вартості запчастин. Остаточна
          вартість залежить від марки автомобіля та складності ремонту і
          узгоджується після діагностики.
        </p>
      </div>
    </section>;
}